module.exports = __webpack_public_path__ + "img/Group 455t2.75210649.svg";